export type PayinDepositInstructions = {
  currency?: string;
  bank?: string;
  pix_key?: string;
  account_number?: string;
  account_alias?: string;
  beneficiary?: string;
  identity_number?: string;
  identity_type?: string;
  email?: string;
  account_type?: string;
  agency?: string;
  expiration_date?: string;
  payer_name?: string;
};

export type PayinCreatedView = {
  instructions: PayinDepositInstructions | null;
  isManualValidation: boolean;
  providerError: string;
  message: string;
  transactionId: string | number | null;
};

function asRecord(value: any): Record<string, any> | null {
  return value && typeof value === 'object' && !Array.isArray(value)
    ? value
    : null;
}

export function extractPayinLinkError(err: any): string {
  const body = err?.error && typeof err.error === 'object' ? err.error : err;
  const nested = body && typeof body === 'object' ? body.data : null;
  const candidates = [
    body?.provider_error,
    body?.providerError,
    body?.message,
    body?.error,
    nested?.message,
    nested?.error,
    err?.message,
  ];
  for (const value of candidates) {
    const text = String(value || '').trim();
    if (text && text.toLowerCase() !== 'error') {
      return text;
    }
  }
  return 'No se pudo crear el link de pago.';
}

function parseMetadata(source: any): Record<string, any> {
  let meta = source?.metadata;
  if (typeof meta === 'string') {
    try {
      meta = JSON.parse(meta);
    } catch {
      meta = {};
    }
  }
  return asRecord(meta) || {};
}

export function extractDepositInstructions(
  source: any,
): PayinDepositInstructions | null {
  if (!source) return null;
  const meta = parseMetadata(source);
  const nested = asRecord(source.data);
  const raw =
    source.deposit_instructions ||
    source.depositInstructions ||
    nested?.['deposit_instructions'] ||
    nested?.['depositInstructions'] ||
    meta['deposit_instructions'] ||
    meta['depositInstructions'];
  const instr = asRecord(raw);
  if (!instr) return null;
  if (
    instr['pix_key'] ||
    instr['account_number'] ||
    instr['account_alias'] ||
    instr['bank'] ||
    instr['beneficiary']
  ) {
    return instr as PayinDepositInstructions;
  }
  return null;
}

export function parsePayinCreatedView(data: any): PayinCreatedView {
  const payload = asRecord(data) || {};
  const nested = asRecord(payload['data']);
  const root = nested && (nested['transaction_id'] != null || nested['payin_id'] != null)
    ? nested
    : payload;
  const message = String(root['message'] || payload['message'] || '').trim();
  const providerError = String(
    root['provider_error'] ||
      root['providerError'] ||
      payload['provider_error'] ||
      payload['providerError'] ||
      '',
  ).trim();
  return {
    instructions: extractDepositInstructions(root) || extractDepositInstructions(payload),
    isManualValidation:
      Boolean(providerError) || /validaci[oó]n manual/i.test(message),
    providerError,
    message,
    transactionId:
      root['transaction_id'] ??
      root['transactionId'] ??
      payload['transaction_id'] ??
      null,
  };
}
